import { PageContent, PageHeader, PageTitle } from '~/elements/PageHeader'
import { WorkspacesLayout } from '~/features/workspaces/layout/WorkspacesLayout'
import { useCurrentWorkspacePlan } from '~/features/billing/hooks/useBillingHooks'
import { formatCount } from '~/features/billing/utils'
import { UsageEstimate, UsageMeters } from '~/components/billing/UsageMeters.tsx'

function LimitTile({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex flex-col gap-1 rounded-xl border bg-fill2 p-4">
      <span className="text-xs font-medium tracking-wide text-content3 uppercase">{label}</span>
      <span className="font-mono text-base font-semibold text-content">{value}</span>
    </div>
  )
}

export function WorkspaceApiUsagePage() {
  const { state, loading } = useCurrentWorkspacePlan()

  return (
    <WorkspacesLayout>
      <PageHeader contained>
        <PageTitle>Usage</PageTitle>
      </PageHeader>
      <PageContent className="gap-6" contained>
        <UsageMeters loading={loading} state={state} />
        {state && (
          <>
            <UsageEstimate state={state} />
            <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
              <LimitTile label="Projects" value={formatCount(state.limits.projects)} />
              <LimitTile label="Seats" value={formatCount(state.limits.seats)} />
              <LimitTile label="Concurrent queries" value={formatCount(state.limits.concurrentQueries)} />
              <LimitTile label="Requests / second" value={formatCount(state.limits.requestsPerSecond)} />
            </div>
          </>
        )}
      </PageContent>
    </WorkspacesLayout>
  )
}
